import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
  const appVersion = require('../../package.json').version
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?_=${appVersion}`);
}
